import axios from "axios";
import { reactive } from "vue";

// GDPR S9 (GDPR-122) — starea Protecția datelor a valorilor email/telefon afișate: `state` pentru chipul de lângă
// valoare, `callWarning` pentru apel (orice negativ pe canal). Serverul caută exact valoarea afișată, nu slotul, deci un
// slot rescris între timp de alt operator nu mută starea pe alt număr. Valorile pleacă în body, niciodată în URL
// (query string-urile ajung în loguri). Contorul se incrementează după o mutație Privacy pe record, iar fișa recitește
// singură (fără buton Refresh). Apelul se verifică din nou la fiecare click; o citire eșuată nu blochează apelul.
export const privacyContactabilityChanges = reactive({ version: 0 });
export const notifyPrivacyContactabilityChanged = () => { privacyContactabilityChanges.version += 1; };

// Înainte de un apel, browserul permite deschiderea `tel:` doar câteva secunde după click: citirea are o limită scurtă.
export const CALL_CHECK_TIMEOUT_MS = 2000;
export const CONTACT_SLOT_PATTERN = /^(email|phone)_(primary|secondary|tertiary)$/;
const MAX_VALUES = 12;

// `values`: `[{ key, type: "email" | "phone", value }]`; rezultatul e indexat pe `key`, fără valori.
export const fetchContactabilityByKey = async (values, http = axios, { timeout } = {}) => {
  const list = (Array.isArray(values) ? values : [])
    .filter((entry) => entry?.key && ["email", "phone"].includes(entry.type) && String(entry.value ?? "").trim())
    .slice(0, MAX_VALUES).map(({ key, type, value }) => ({ key, type, value: String(value) }));
  if (!list.length) return {};
  const { data } = await http.post("/ncrm/privacy/contactability", { values: list }, timeout ? { timeout } : {});
  const items = Array.isArray(data?.items) ? data.items : [];
  return Object.fromEntries(items.filter((item) => item?.key)
    .map((item) => [item.key, { state: item.state, callWarning: item.call_warning === true }]));
};

// La click: exact numărul care se formează.
export const fetchCallWarning = async (phone, http = axios, options = {}) =>
  (await fetchContactabilityByKey([{ key: "call", type: "phone", value: phone }], http, options)).call?.callWarning === true;

// Deschide aplicația de apel; obiect mutabil ca testele să poată înlocui navigarea.
export const phoneDialer = { dial: (href) => window.location.assign(href) };
